import {Injectable} from '@angular/core';
import {environment} from "../../../environments/environment";
import {GoogleCookiesPolicy} from "./google-cookies-policy";
import {CookiePolicy} from "./cookie-policy";
import {FakeCookiePolicyService} from "./fake-cookie-policy.service";

@Injectable({
	providedIn: 'root'
})
export class CookiePolicyFactoryService {
	private cookiesIdsAndNames: { [id: string]: string[] };

	private policies = {
		'statistics.google': new GoogleCookiesPolicy()
	}

	constructor() {}

	setCookiesIdsAndNames(cookiesIds: { [id: string]: string[] }) {
		this.cookiesIdsAndNames = cookiesIds;
	}

	handle(cookieId: string, isAccepted: boolean) {
		if (!environment.realCookies) {
			new FakeCookiePolicyService().handle(this.cookiesIdsAndNames[cookieId], isAccepted)
		} else {
			const policy: CookiePolicy = this.policies[cookieId];
			policy?.handle(this.cookiesIdsAndNames[cookieId], isAccepted);
		}
	}
}
